export const ActionTypes = {
  LOADING: "GET_PREDEFINED_METRICS_LOADING",
  ERROR: "GET_PREDEFINED_METRICS_ERROR",
  SUCCESS: "GET_PREDEFINED_METRICS_SUCCESS"
};
